import React from "react"
import {SelectMenu} from "../forms"
import {Field, } from "redux-form"
import { Errors } from "../../api/util"
import { connect } from "react-redux"

let NewCustomerSelectMenu = (props) => {

    return <Field name="howtoregister" id="howtoregister" onChange={(e,n,p)=>{ props.dispatch(Errors.clear())}}
                  options={[
                      {value: 'company', label: "As a company"},
                      {value: 'myself', label: "As myself"}
                  ]}
                  component={SelectMenu} title="How do you want to register?"/>

};

NewCustomerSelectMenu = connect()(NewCustomerSelectMenu)

export {NewCustomerSelectMenu}